import { Link } from "react-router-dom";
import { Compass } from "lucide-react";

export default function NotFound() {
  return (
    <div className="pt-16 lg:pt-[72px] min-h-[70vh] flex items-center justify-center" data-testid="notfound-page">
      <div className="text-center px-4">
        <Compass size={48} className="mx-auto text-indic-gold/60" />
        <h1 className="mt-6 font-serif text-6xl text-amber-50">Lost the path</h1>
        <p className="mt-3 text-slate-400">This page is not within the civilisation — yet.</p>
        <Link to="/" className="mt-8 inline-block rounded-sm bg-indic-gold px-6 py-3 font-semibold text-indic-indigo hover:bg-indic-gold-soft transition-colors" data-testid="notfound-home">Return home</Link>
      </div>
    </div>
  );
}
